import { Dropdown } from 'react-bootstrap';
import '../assets/Calendar.css';

export const TakeawayDropdown = ({ order, setOrder }) => {
  const options = ['Κατανάλωση ΛΑΦΑ', 'Παραλαβή ΣΠΑ', 'Παραλαβή ΛΑΦΑ'];

  const handleSelect = (selectedOption) => {
    setOrder({ ...order, takeaway: selectedOption });
  };

  return (
    <Dropdown onSelect={handleSelect}>
      <Dropdown.Toggle variant="outline-secondary" id="dropdown-basic">
        {order?.takeaway ? order?.takeaway : "Σημείο Παραλαβής"}
      </Dropdown.Toggle>

      <Dropdown.Menu>
        {options.map((option, index) => (
          <Dropdown.Item key={index} eventKey={option}>
            {option}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
};
